import React from "react";

const Mensagem = ({ children }) => {
  return <p style={{ color: "#4D4D4D", fontSize: "13px" }}>{children}</p>;
};

const MensagensBoletoGerado = () => {
  return (
    <div style={{ marginTop: "32px" }}>
      <p style={{ fontSize: "13px", color: "#ba122b", fontWeight: "bold" }}>
        Informações importantes sobre seu boleto:
      </p>
      <Mensagem estilo={{ color: "red" }}>
        - O boleto é gerado com a soma e desconto(s) aplicados às parcelas
        selecionadas;
      </Mensagem>
      <Mensagem>
        - O boleto é válido por até 20 dias, tendo encargos após o seu
        vencimento;
      </Mensagem>
      <Mensagem>
        - Caso o seu computador tenha um programa anti pop-up, será preciso
        desativá-lo antes de finalizar e imprimir o boleto ou pagar pelo
        internet banking;
      </Mensagem>
      <Mensagem>
        - Não faça depósito ou transferência entre contas. O boleto não é
        enviado pelos correios, imprima-o e pague-o no banco ou pela internet;
      </Mensagem>
      <Mensagem>
        - Se o boleto não for pago até a data de vencimento, pode receber
        encargos como juros e multa; parcelas pagas com boleto bancário começam
        a contar três dias depois do pagamento do boleto, tempo necessário para
        que a instituição bancária confirme o pagamento.
      </Mensagem>
    </div>
  );
};

export default MensagensBoletoGerado;
